import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";
import { useId } from "react";

import { colors } from "@/theme/tokens/colors";

export const SprengnetterLogo = (props: SvgIconProps): JSX.Element => {
  const clip0 = useId();
  const clip1 = useId();
  const clip2 = useId();
  const clip3 = useId();
  const clip4 = useId();
  const clip5 = useId();
  const clip6 = useId();
  const clip7 = useId();
  const clip8 = useId();
  const clip9 = useId();
  const clip10 = useId();
  const clip11 = useId();
  const clip12 = useId();

  return (
    <SvgIcon viewBox="0 0 120 30" sx={{ width: "120px", height: "30px", display: "block" }} {...props}>
      <g clipPath={`url(#${clip0})`}>
        <path
          d="M99.9844 10.1733V11.7786H97.2972C97.2811 11.7786 97.079 11.9824 97.079 11.9971V19.9531H95.3356V11.7772H89.8158V19.9531H88.0724V11.7772H85.3125V10.1719H99.9815L99.9844 10.1733Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip1})`}>
        <path
          d="M61.6719 19.9566C61.4116 19.9141 60.1323 20.0152 60.0741 19.9566C60.0015 19.8833 60.1861 18.792 60.0029 18.7861C58.8936 20.4128 56.1837 20.4377 54.5671 19.5811C52.2425 18.349 51.6711 15.216 52.5434 12.8911C54.115 8.70637 61.0017 9.0584 61.6719 13.6744C61.3012 13.5966 60.0116 13.7946 59.8037 13.6568C59.7427 13.6157 59.6932 13.2138 59.6046 13.0554C57.9705 10.1409 53.3895 11.7191 54.0408 15.8745C54.586 19.3552 59.3254 19.4916 60.0741 16.1591H57.4602V14.553H61.6719V19.9581V19.9566Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip2})`}>
        <path
          d="M64.8594 10.1646C65.3939 10.2467 66.4237 9.98118 66.8173 10.3113L71.2429 16.8854V10.1646H72.9844V19.9531L71.1281 19.9223L66.6023 13.2323V19.9531H64.8608V10.1646H64.8594Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip3})`}>
        <path
          d="M47.8841 17.0251V10.1632H49.4844V19.9458C48.9631 19.8696 48.0646 20.1233 47.6686 19.7978L43.0847 13.0839V19.9458H41.4844V10.1632C41.9984 10.2394 42.9158 9.98725 43.3016 10.3098L47.8841 17.0251Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip4})`}>
        <path
          d="M25.6096 10.1648C28.515 10.5771 28.8916 15.0191 26.12 15.9347L28.2969 19.954C27.8068 19.8674 26.6348 20.1125 26.2611 19.8836C25.8873 19.6547 24.5844 16.1548 24.3023 16.1548H22.1967V19.954H20.4531V10.1633C22.0527 10.3262 24.0624 9.94467 25.6096 10.1633V10.1648ZM22.1967 14.548H25.1748C26.0269 14.548 26.4966 13.2038 26.0996 12.4466C26.0095 12.2749 25.4584 11.7702 25.3202 11.7702H22.1967V14.5465V14.548Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip5})`}>
        <path
          d="M117.458 10.1709C120.309 10.6177 120.621 15.0074 117.963 15.9378C118.559 17.2945 119.592 18.5487 120 19.9451C119.486 19.8645 118.399 20.1253 118.037 19.8015L116.222 16.1517H114.042V19.9451H112.297V10.1694C113.873 10.3452 115.945 9.93204 117.458 10.1694V10.1709ZM114.04 14.5473H116.875C116.96 14.5473 117.65 14.2133 117.744 14.1063C118.383 13.3928 117.931 11.7752 117.021 11.7752H114.04V14.5473Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip6})`}>
        <path
          d="M83.1562 10.1719V11.7772H77.9172V14.2591H82.8649V15.8659H77.9172V18.3478H83.1562V19.9531H76.1719V10.1719H83.1562Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip7})`}>
        <path
          d="M109.125 10.1719V11.7772H103.886V14.2591H108.834V15.8659H103.886V18.3478H109.125V19.9531H102.141V10.1719H109.125Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip8})`}>
        <path
          d="M38.1719 10.1719V11.7772H33.0864V14.2591H38.0264V15.8659H33.0864V18.3478H38.1719V19.9531H31.3438V10.1719H38.1719Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip9})`}>
        <path
          d="M7.40275 13.2352C7.06271 13.1634 6.028 13.3452 5.82455 13.2147C5.70538 13.1384 5.6676 12.1266 4.89157 11.7439C3.22472 10.9198 1.22943 12.4947 2.47049 13.5945C3.58367 14.5828 7.06416 13.9611 7.5132 16.407C8.39387 21.2065 0.0247049 21.513 0 16.8851C0.308085 16.9452 1.60146 16.7912 1.72498 16.9012C1.7773 16.9467 1.90082 17.7855 2.31209 18.1344C3.43834 19.0905 6.45525 18.5333 5.69522 16.7736C5.09067 15.3762 0.834155 16.2663 0.447595 13.4391C-0.177294 8.86683 7.70358 8.78617 7.40275 13.2338V13.2352Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip10})`}>
        <path
          d="M99.9844 0.112788V7.125H98.2408V1.71914C94.2983 1.64726 90.5783 3.04236 87.0561 4.64138V7.125H85.3125V3.83747C89.5182 1.06927 94.9411 -0.438801 99.983 0.112788H99.9844Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip11})`}>
        <path
          d="M87.0549 23V25.3357C90.5657 26.9514 94.3035 28.359 98.2405 28.2564V23H99.9844V29.8619C94.8504 30.5202 89.7731 28.7387 85.3125 26.3576V23H87.0563H87.0549Z"
          fill={colors.brand.blue}
        />
      </g>
      <g clipPath={`url(#${clip12})`}>
        <path
          d="M12.0379 16.1576V19.9531H10.4375V10.1719H15.3102C15.4573 10.1719 16.267 10.5193 16.4505 10.6337C18.2315 11.7376 18.1572 14.8177 16.2422 15.7794C16.0995 15.8512 15.2417 16.1576 15.1646 16.1576H12.0365H12.0379ZM12.0379 14.5509H14.8748C15.7471 14.5509 16.2131 13.2432 15.801 12.453C15.7121 12.2815 15.1573 11.7772 15.0204 11.7772H12.0379V14.5509Z"
          fill={colors.brand.blue}
        />
      </g>
      <defs>
        <clipPath id={clip0}>
          <rect width="14.6719" height="9.78125" fill="white" transform="translate(85.3125 10.1719)" />
        </clipPath>
        <clipPath id={clip1}>
          <rect width="9.51562" height="10.1719" fill="white" transform="translate(52.1562 9.96875)" />
        </clipPath>
        <clipPath id={clip2}>
          <rect width="8.125" height="9.8125" fill="white" transform="translate(64.8594 10.1406)" />
        </clipPath>
        <clipPath id={clip3}>
          <rect width="8" height="9.82812" fill="white" transform="translate(41.4844 10.1406)" />
        </clipPath>
        <clipPath id={clip4}>
          <rect width="7.84375" height="9.89062" fill="white" transform="translate(20.4531 10.0938)" />
        </clipPath>
        <clipPath id={clip5}>
          <rect width="7.70312" height="9.875" fill="white" transform="translate(112.297 10.0938)" />
        </clipPath>
        <clipPath id={clip6}>
          <rect width="6.98438" height="9.78125" fill="white" transform="translate(76.1719 10.1719)" />
        </clipPath>
        <clipPath id={clip7}>
          <rect width="6.98438" height="9.78125" fill="white" transform="translate(102.141 10.1719)" />
        </clipPath>
        <clipPath id={clip8}>
          <rect width="6.82812" height="9.78125" fill="white" transform="translate(31.3438 10.1719)" />
        </clipPath>
        <clipPath id={clip9}>
          <rect width="7.57812" height="10.2344" fill="white" transform="translate(0 9.95312)" />
        </clipPath>
        <clipPath id={clip10}>
          <rect width="14.6719" height="7.125" fill="white" transform="translate(85.3125)" />
        </clipPath>
        <clipPath id={clip11}>
          <rect width="14.6719" height="7" fill="white" transform="translate(85.3125 23)" />
        </clipPath>
        <clipPath id={clip12}>
          <rect width="7.29688" height="9.78125" fill="white" transform="translate(10.4375 10.1719)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
